import { strategyToOptions } from "@/common/utils/strategyToOptions";
import { DashboardVisibility } from "../../types/dashboards/dashboard.type";

export const dashboardVisibility: Record<DashboardVisibility, string> = {
  [DashboardVisibility.CreatorUserOnly]: 'Apenas eu',
  [DashboardVisibility.SameCompany]: 'Todos da mesma empresa'
}

export const dashboardVisibilityOptions = strategyToOptions(dashboardVisibility);
